import { nonEmpty, object, pipe, string, trim } from "valibot";

export const IntegrationApiKeySchema = object({
  api_key: pipe(string(), trim(), nonEmpty("API key is required")),
});
